import { styled } from '@mui/material/styles';
import { Button as MUIButton } from '@mui/material';

export const Button = styled(MUIButton)(({ theme }) => ({
	borderradius: theme.shape.borderradius,
	texttransform: 'none',
	fontweight: 600,
	padding: theme.spacing(1, 3),
	// transition: 'all 0.3s ease',
	'&:hover': {
		fontweight: 800
	}
}));
